import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { acGetAllAccessKeys, acGetAccessKey } from '../../store/actions'
import { DataTable } from '../default'
import { CreateAccessKeyModal, UpdateAccessKeyModal } from '../modals'

/**
 * @description AccessKeysTable function displays a table of access keys.
 * The function fetches all access keys from the server and renders them in a table format.
 * It also provides functionality to create and update access keys.
 * 
 * @author Isadora Botasssari, Maria Eduarda Franke
 * @returns {JSX.Element} The AccessKeysTable component
 */
const AccessKeysTable = () => {

    const dispatch = useDispatch()

    const [openCreateModal, setOpenCreateModal] = useState(false)
    const [openUpdateModal, setOpenUpdateModal] = useState(false)

    // Get All Access Keys
    const allKeys = useSelector(state => state.accessKeys.allKeys)
    const isLoadingAllKeys = useSelector(state => state.accessKeys.isLoadingAllKeys)
    const hasErrorAllKeys = useSelector(state => state.accessKeys.hasErrorAllKeys)
    // Create and Update Access Key
    const selectedKey = useSelector(state => state.accessKeys.selectedKey)
    const isCreatingKey = useSelector(state => state.accessKeys.isCreatingKey)
    const isUpdatingKey = useSelector(state => state.accessKeys.isUpdatingKey)

    useEffect(() => {
        dispatch(acGetAllAccessKeys())
            .catch(error => console.error(error))
        // eslint-disable-next-line
    }, [])

    const columns = [
        {
            accessorKey: 'application_access_key_id',
            header: 'ID',
            enableEditing: false,
            size: 80
        },
        {
            accessorKey: 'applicationService.name',
            header: 'Aplicação',
            size: 300
        }
    ]

    // Handle Create Action
    const onCreate = () => {
        setOpenCreateModal(!openCreateModal)
    }

    // Handle Switch Action: Activate or Desactivate Access Key
    const onSwitch = (row) => {
        dispatch(acGetAccessKey(row.original.application_access_key_id))
            .then(() => {
                setOpenUpdateModal(!openUpdateModal)
            })
            .catch(error => console.error(error))
    }

    return (
        <>
            <CreateAccessKeyModal
                open={openCreateModal}
                onClose={() => setOpenCreateModal(!openCreateModal)}
            />
            <UpdateAccessKeyModal
                open={openUpdateModal}
                onClose={() => setOpenUpdateModal(!openUpdateModal)}
                selectedAccessKey={selectedKey}
            />
            <DataTable
                resource='Chave'
                gender='fem'
                tableType='switch'
                columns={columns}
                data={allKeys}
                onCreate={onCreate}
                onSwitch={onSwitch}
                isLoading={isLoadingAllKeys}
                isSaving={isCreatingKey || isUpdatingKey}
                showAlertBanner={hasErrorAllKeys}
            />
        </>
    )

}

export default AccessKeysTable